import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';

import Isvg from 'react-inlinesvg';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



class Date extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }






    render() {
        return (
            <>
                {this.props.label ? <label className={this.props.error ? "label" : "label"}>{this.props.label}</label> : null}
                <DatePicker
                    onChange={this.props.onChange}
                    selected={this.props.value}
                    dateFormat="dd-MM-yyyy"
                    className="datepicker"
                    
                />

            </>


        );
    }
}

export default Date;